import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { behindJumpRegister } from "./components/behindJump/index";
import { operationLogRegister } from "./components/operationLog/index";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const open = ref(true);

behindJumpRegister();
operationLogRegister('operation-log')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = true))
  }, "ddd"))
}
}

})